import { ResetOrderPayload } from '@fingermarkglobal/types';
import { resetOrder } from '../requests/reset-order';
import { createMachine, assign } from 'xstate';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;
    
    if (data) {
      logger.debug(`[fm-api][order/reset] - data received:`, data);
      return data
    };

    if (error) {
      logger.error(`[fm-api][order/reset] - error received:`, error);
      return error
    };

    logger.error(`[fm-api][order/reset] - message received:`, message);
    return message;
  }
});

const createResetOrderMachine = ({ payload = null, timeout = 30, ip = undefined, provider = '' } = {}) =>
  createMachine<{ ip?: string; payload: ResetOrderPayload; timeout: number; data: unknown; provider: string }>(
    {
      id: 'resetOrderMachine',
      initial: 'processing',
      context: {
        ip,
        payload,
        timeout,
        data: null,
        provider
      },
      states: {
        processing: {
          invoke: {
            src: ({ payload, timeout, ip }) => resetOrder(payload, timeout, ip, provider),
            onDone: {
              target: 'success',
              actions: ['populateMessage']
            },
            onError: {
              target: 'error',
              actions: ['populateMessage']
            }
          }
        },
        success: {
          on: {
            RETRY: 'processing'
          }
        },
        error: {
          type: 'final',
          entry: ['populateMessage']
        }
      }
    },
    {
      actions: {
        populateMessage
      }
    }
  );

export { createResetOrderMachine };
